import { Regeling } from "@klantondersteuning/client";
import { RegelingOptions } from "../interface/SimpleForm/RegelingOptions";

export function mapRegelingOptionToRegeling(regelingOption: RegelingOptions | string): Regeling {
    switch (regelingOption) {
      case RegelingOptions.BeschermdWonen:
        return Regeling.BeschermdWonen;
      case RegelingOptions.Buitenland:
        return Regeling.Buitenland;
      case RegelingOptions.CBHC:
        return Regeling.CBHC;
      case RegelingOptions.Gemoedsbezwaarden:
        return Regeling.Gemoedsbezwaarden;
      case RegelingOptions.MedicijnenMeeOpReis:
        return Regeling.MedicijnenMeeOpReis;
      case RegelingOptions.Onbekend:
        return Regeling.Onbekend;
      case RegelingOptions.OnverzekerbareVreemdelingen:
        return Regeling.OnverzekerbareVreemdelingen;
      case RegelingOptions.Onverzekerden:
        return Regeling.Onverzekerden;
      case RegelingOptions.SOV:
        return Regeling.SOV;
      case RegelingOptions.BetalingsachterstandZorgpremie:
        return Regeling.BetalingsachterstandZorgpremie;
      case RegelingOptions.Wlz:
        return Regeling.Wlz;
      case RegelingOptions.WmoAT:
        return Regeling.WmoAT;
      default:
        throw Error(`Unknown regeling: '${regelingOption}'`);
    }
  }